<script setup lang="ts">
import { computed } from 'vue';
import Dialog from 'primevue/dialog';
import { ButtonType, CustomButton } from '@/components';
import { useI18n } from 'vue-i18n';

const { t: $t } = useI18n();

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  discard: {
    type: Boolean,
    default: false
  }
});

const emits = defineEmits(['onClose', 'onDiscard', 'onSave']);

const closeDialog = () => {
  emits('onClose');
};

const discardChanges = () => {
  emits('onDiscard');
};

const saveChanges = () => {
  emits('onSave', true);
};

const buttonJustigyContent = computed(() => props.discard ? 'end' : 'space-between');
</script>

<template>
  <div class="dialog-root">
    <Dialog :visible="visible"
      :header="discard ? $t('discard_changes') : $t('unsaved_changes')"
      modal
      class="dialog"
      append-to="self"
      @update:visible="closeDialog">
      <div class="content-root">
        <div class="alert-message-container">
          <FontAwesomeIcon :icon="[`fas`, `exclamation-triangle`]"
            class="exclamation-icon"/>
          <p class="alert-message" v-if="!discard">
            {{ $t('unsaved_changes_msg') }}
          </p>
          <p class="alert-message" v-if="discard">
            {{ $t('discard_changes_msg') }}
          </p>
        </div>
        <div class="alert-message-buttons">
          <CustomButton :text="$t('discard_changes')"
            @onClick="discardChanges"
            :type="ButtonType.NEGATIVE_OUTLINED"/>
          <div class="footer-buttons" v-if="!discard">
            <CustomButton :text="$t('cancel')"
              @onClick="closeDialog"
              :type="ButtonType.OUTLINED"/>
            <CustomButton :text="$t('save_changes')"
              :margin-left="16"
              @onClick="saveChanges"
              :type="ButtonType.POSITIVE"/>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<style scoped lang="scss">
@use "../../../assets/dialog" as *;
:deep(.p-dialog) {
  width: 600px;
}
:deep(.p-dialog-header) {
  padding: unset;
  padding: 40px 40px 0px 40px;
}
:deep(.p-dialog-content) {
  padding: unset;
}
.content-root {
  padding: 20px 40px 40px 40px;
}
.alert-message-container {
  display: flex;
  align-items: center;

  .exclamation-icon {
    font-size: 42px;
    color: #828e99;
    margin-right: 24px;
  }

  .alert-message {
    font-size: 14px;
    max-width: 380px;
    line-height: 20px;
    color: #575e66;
  }
}
.alert-message-buttons {
  display: flex;
  align-items: center;
  justify-content: v-bind(buttonJustigyContent);
  padding-top: 40px;

  .footer-buttons {
    display: flex;
  }
}
</style>
